import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import './Header.css'
import { track } from '@vercel/analytics'

const Header: React.FC = () => {
  const [trailersDropdownOpen, setTrailersDropdownOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setTrailersDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setTrailersDropdownOpen(false);
    }, 200);
  };

  const handleNavClick = (navItem: string) => {
    track('navbar_click', {
      nav_item: navItem,
      location: 'header_navigation',
      page: window.location.pathname
    });
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/images/logos/fbt-logo-3-noborder.jpeg" alt="Fast Boat Trailers" className="logo-image" loading="eager" />
          </Link>
          <div className="made-in-usa">
            <div className="usa-badge">
              <span className="usa-text">Made in the</span>
              <span className="usa-flag">🇺🇸</span>
              <span className="usa-text">USA</span>
            </div>
          </div>
          <nav className="nav">
            <div
              className="nav-dropdown"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link to="/trailers" className="nav-link" onClick={() => handleNavClick('trailers')}>
                Trailers <span className="dropdown-arrow">▼</span>
              </Link>
              {trailersDropdownOpen && (
                <div className="dropdown-menu">
                  <Link to="/trailers" className="dropdown-item" onClick={() => handleNavClick('all_trailers')}>All Trailers</Link>
                  <Link to="/trailers/aluminum" className="dropdown-item" onClick={() => handleNavClick('aluminum_trailers')}>Aluminum Trailers</Link>
                  <Link to="/trailers/bunk" className="dropdown-item" onClick={() => handleNavClick('bunk_trailers')}>Bunk Trailers</Link>
                  <Link to="/trailers/commander" className="dropdown-item" onClick={() => handleNavClick('commander_line')}>Commander Line</Link>
                  <Link to="/trailers/galvanized" className="dropdown-item" onClick={() => handleNavClick('galvanized_trailers')}>Galvanized</Link>
                  <Link to="/trailers/pwc" className="dropdown-item" onClick={() => handleNavClick('pwc_trailers')}>Personal Watercraft</Link>
                  <Link to="/trailers/pontoon" className="dropdown-item" onClick={() => handleNavClick('pontoon_trailers')}>Pontoon/Tritoon</Link>
                  <Link to="/trailers/roller" className="dropdown-item" onClick={() => handleNavClick('roller_trailers')}>Roller Trailers</Link>
                  <Link to="/trailers/skiff" className="dropdown-item" onClick={() => handleNavClick('skiff_trailers')}>Skiff & Jon Boat</Link>
                  <Link to="/trailers/accessories" className="dropdown-item" onClick={() => handleNavClick('accessories')}>Accessories</Link>
                </div>
              )}
            </div>
            <Link to="/inventory" onClick={() => handleNavClick('inventory')}>Inventory</Link>
            <Link to="/tips" onClick={() => handleNavClick('tips')}>Tips</Link>
            <Link to="/about" onClick={() => handleNavClick('about')}>About</Link>
            <Link to="/contact" onClick={() => handleNavClick('contact')}>Contact</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;